import React from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const MapPage = () => {
    return (
        <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', background: 'linear-gradient(160deg, #000000 0%, #06222f 55%, #003048 100%)', position: 'relative' }}>
            {/* Geri dön butonu */}
            <a
                href='/'
                style={{
                    position: 'fixed',
                    top: 16,
                    left: 16,
                    zIndex: 1000,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '9px 18px',
                    color: '#e7e7f0',
                    background: 'rgba(10,10,18,0.72)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    borderRadius: 999,
                    backdropFilter: 'blur(10px)',
                    textDecoration: 'none',
                    fontSize: 14,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    transition: 'all .2s ease',
                }}
                onMouseOver={(e) => (e.currentTarget.style.borderColor = '#e0a83e')}
                onMouseOut={(e) => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)')}
            >
                <span style={{ fontSize: 18, lineHeight: 1 }}>←</span> Ana Sayfa
            </a>

            {/* Harita üst bilgi */}
            <div
                style={{
                    position: 'fixed',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1000,
                    padding: '8px 18px',
                    color: 'rgba(255,255,255,0.75)',
                    background: 'rgba(10,10,18,0.6)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: 999,
                    backdropFilter: 'blur(10px)',
                    fontSize: 13,
                    fontWeight: 600,
                    letterSpacing: 0.5,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none',
                    userSelect: 'none',
                }}
            >
                🗺️ Harita — kaydırarak hareket ettir, tekerlekle yakınlaştır
            </div>

            <TransformWrapper
                defaultScale={2}
                minScale={0.5}
                maxScale={5}
                wheel={{ step: 0.1 }}
                pinch={{ step: 5 }}
                doubleClick={{ disabled: true }}
                pan={{ disabled: false }}
                limitToBounds={false}
                centerOnInit={false}
            >
                <TransformComponent>
                    <img
                        src="/map.jpg"
                        alt="Harita"
                        style={{
                            width: 'auto',
                            height: '100vh',
                            display: 'block',
                            userSelect: 'none',
                            pointerEvents: 'auto',
                        }}
                        draggable={false}
                    />
                </TransformComponent>
            </TransformWrapper>
        </div>
    );
};

export default MapPage;
